import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5712c1ee")

_pushScopeId("data-v-5712c1ee")
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-m-4" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-d-flex p-flex-row p-jc-around" }
const _hoisted_6 = { class: "input-help" }
const _hoisted_7 = { class: "p-field p-col-12" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-d-flex p-flex-row p-jc-around" }
const _hoisted_11 = { class: "input-help" }
const _hoisted_12 = { class: "p-field p-col-12" }
const _hoisted_13 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-d-flex p-flex-row" }
const _hoisted_15 = { class: "p-d-flex p-flex-row p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.knParameterSaveDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.saveAs') + ' ... '), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.saveViewpoint,
          disabled: _ctx.saveButtonDisabled
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    default: _withId(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.viewpoint.NAME.$invalid && _ctx.v$.viewpoint.NAME.$dirty
                        }],
              maxLength: _ctx.knParameterSaveDialogDescriptor.nameMaxLength,
              modelValue: _ctx.v$.viewpoint.NAME.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.viewpoint.NAME.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.viewpoint.NAME.$touch()))
            }, null, 8, ["maxLength", "modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.viewpoint.NAME,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('common.name')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"]),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.nameHelp), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_InputText, {
              id: "description",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.viewpoint.DESCRIPTION.$invalid && _ctx.v$.viewpoint.DESCRIPTION.$dirty
                        }],
              maxLength: _ctx.knParameterSaveDialogDescriptor.descriptionMaxLength,
              modelValue: _ctx.v$.viewpoint.DESCRIPTION.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.viewpoint.DESCRIPTION.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.viewpoint.DESCRIPTION.$touch()))
            }, null, 8, ["maxLength", "modelValue", "class"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.description')) + " * ", 1)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.viewpoint.DESCRIPTION,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('common.description')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"]),
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.descriptionHelp), 1)
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.visibility')) + " * ", 1),
          _createVNode(_component_Dropdown, {
            id: "scope",
            class: ["kn-material-input", {
                        'p-invalid': _ctx.v$.viewpoint.SCOPE.$invalid && _ctx.v$.viewpoint.SCOPE.$dirty
                    }],
            modelValue: _ctx.v$.viewpoint.SCOPE.$model,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.viewpoint.SCOPE.$model = $event)),
            options: _ctx.knParameterSaveDialogDescriptor.scopeOptions,
            onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.viewpoint.SCOPE.$touch()))
          }, null, 8, ["modelValue", "class", "options"]),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.viewpoint.SCOPE,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('common.scope')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})